import { CompoundFilter, Filter, findLeafByOn, LeafFilter } from '@itonics/filters';
import { SearchFieldIdentifiers } from '../model/search-interface-model';
import { SignalsFilters, SignalsType } from '../model/types';

export const getSearchFieldContextLeaf: (filter: CompoundFilter, property: string) => LeafFilter = (filter, property) => {
  const searchFieldFilter = filter.getQuery(SignalsFilters.SEARCH_FIELD) as CompoundFilter;
  const contextFilter = searchFieldFilter.getQuery(SearchFieldIdentifiers.CONTEXT) as CompoundFilter;
  if (contextFilter) {
    //  We want here find a LeafFilter by "ON" because we don't have the ID
    return contextFilter.findQuery(findLeafByOn(property)) as LeafFilter;
  }
};

export const getSelectionLeaf: (filter: CompoundFilter, property: string) => LeafFilter = (filter, property) => {
  const originalSelection = filter.getQuery(SignalsFilters.SELECTION) as CompoundFilter;
  if (!(originalSelection && originalSelection.findQuery(findLeafByOn(property)))) {
    return;
  }
  //  We want here find a LeafFilter by "ON" because we don't have the ID
  return originalSelection.findQuery(findLeafByOn(property)) as LeafFilter;
};

/*
    Extract query from filters
 */
export const getQueryFromFilter: (filter: CompoundFilter, filterType: string, desiredFilterType: string) => LeafFilter = (
  filter,
  filterType,
  desiredFilterType
) => {
  if (filterType === SignalsFilters.SEARCH_FIELD) {
    return getSearchFieldContextLeaf(filter, desiredFilterType);
  } else if (filterType === SignalsFilters.SELECTION) {
    return getSelectionLeaf(filter, desiredFilterType);
  }
};

/**
 * Extract time query from filters
 */
export const getTimeQuery: (filter: CompoundFilter, type: string) => LeafFilter = (filter, type) =>
  getQueryFromFilter(filter, type, SignalsType.PUBLISHED_DATE);
/**
 * Extract categories query from filters
 */
export const getCategoriesQuery: (filter: CompoundFilter, type: string) => LeafFilter = (filter, type) =>
  getQueryFromFilter(filter, type, SignalsType.CATEGORY);
/**
 * Extract topics query from filters
 */
export const getTopicsQuery: (filter: CompoundFilter, type: string) => LeafFilter = (filter, type) =>
  getQueryFromFilter(filter, type, SignalsType.TOPICS);

export const isFilterChildOfSearchField: (filter: CompoundFilter) => boolean = (filter: CompoundFilter) => {
  const searchFieldChild: Array<string> = Object.values(SearchFieldIdentifiers);
  if (searchFieldChild.indexOf(filter.getIdentifier()) !== -1) {
    return true;
  }
  return false;
};

/**
 * Check if the Query was removed, this could be used in the subscription of  onFilterChange
 */
export const queryDeselected: (changedFilter: CompoundFilter, property: string) => boolean = (changedFilter, property) => {
  const selectionRemovedThisFilter =
    changedFilter.getIdentifier() === SignalsFilters.SELECTION && !(changedFilter as CompoundFilter).findQuery(findLeafByOn(property));

  if (selectionRemovedThisFilter) {
    return true;
  }

  return false;
};

/**
 * COMPARE filter with exclusion
 */

export const compareLeafByOnAndExclude = (filter1: Filter, filter2: Filter) => {
  try {
    return (
      (filter1 as LeafFilter).getOn() === (filter2 as LeafFilter).getOn() &&
      (filter1 as LeafFilter).getExclude() === (filter2 as LeafFilter).getExclude()
    );
  } catch (e) {
    return false;
  }
};

/**
 * COMPARE Leaf/Compound to Leaf/Compound with exclusion
 * Matches a LeafFilter's '.on' to a CompoundFilter's '.id' or vice versa
 * This allows for filter replacement where the type of the two filters isn't necessarily the same
 */
export const compareLeafOrCompoundByOnIdAndExclude = (filter1: Filter, filter2: Filter) => {
  const getOnOrId = (filter) => (filter instanceof LeafFilter ? filter.getOn() : filter.getIdentifier());

  try {
    return getOnOrId(filter1) === getOnOrId(filter2) && filter1.getExclude() === filter2.getExclude();
  } catch (e) {
    return false;
  }
};

/**
 *
 * FIND filter with exclusion
 */

export const findLeafByOnAndExclude = (on: string, exclude: boolean) => (filter: Filter) => {
  try {
    return (filter as LeafFilter).getOn() === on && (filter as LeafFilter).getExclude() === exclude;
  } catch (e) {
    return false;
  }
};

/**
 * Find filter with exclusion, skipping any filters that have hasValue=false
 */

export const findLeafByOnAndExcludeWithValue = (on: string, exclude: boolean) => (filter: Filter) => {
  try {
    return (
      (filter as LeafFilter).getOn() === on &&
      (filter as LeafFilter).getExclude() === exclude &&
      !((filter as LeafFilter).getHasValue() === false)
    );
  } catch (e) {
    return false;
  }
};
